
import ActionButton from './ActionButton.vue'
import SpinnerOct from './SpinnerOct.vue'

export default {
	name: 'WebhookLogs',
	components: { SpinnerOct, ActionButton },
	inject: [ 'baseEndpoint', 'spaceId', 'permissions' ],
	props: {
		webhook: { type: Object, required: true },
	},
	data: () => ({
		logs: null,
		loading: false,
	}),
	methods: {
		/*
		val webhookId: String,
		val timeframeFrom: String (iso)? = null,
		val timeframeTo: String (iso)? = null,
		val limit: Int? = null,
		val offset: String? = null,
		*/
		async loadLogs() {
			const params = {
				timeframeFrom: new Date(Date.now() - 7 * 24 * 3600 * 1000).toISOString(),
				limit: 2000,
			}
			const r = await this.$httpPost(this.baseEndpoint + '/spaces/' + this.spaceId + '/webhook_definitions/' + this.webhook.sys.id + '/logs', params)
			for (const log of r.items) {
				log.open = false
			}
			return r.items
		},
		async load() {
			this.loading = true
			this.logs = await this.loadLogs()
			this.loading = false
		},
	},
}
